import config from './../config/config';


/**
 * Gets paths to all images in the explosion sequence
 * @returns {Array<String>} An array of image paths
 */
function getExplosionPaths() {
  const explosionAnimationImagePaths = [];

  for (let i = 0; i < 6; i++) {
    const num = (i + 1);
    const imagePath = 'assets/images/explosion/explosion-' + num + '.png';

    explosionAnimationImagePaths.push(imagePath);
  }

  return explosionAnimationImagePaths;
}


/**
 * Gets paths to all images in the explosion sequence
 * @returns {Array<String>} An array of image paths
 */
function getSplashPaths() {
  const splashAnimationImagePaths = [];

  for (let i = 0; i < 6; i++) {
    const num = (i + 1);
    const imagePath = 'assets/images/splash/splash-' + num + '.png';

    splashAnimationImagePaths.push(imagePath);
  }

  return splashAnimationImagePaths;
}


/**
 * Gets paths to all images in the ball sequence
 * @returns {Array<String>} An array of image paths
 */
function getBallPaths() {
  const ballAnimationImagePaths = [];

  for (let i = 0; i < 3; i++) {
    const num = (i + 1);
    const imagePath = 'assets/images/ball/ball-' + num + '.gif';

    ballAnimationImagePaths.push(imagePath);
  }

  return ballAnimationImagePaths;
}

/**
 * Gets paths to all images in the fireball sequence
 * @returns {Array<String>} An array of image paths
 */
function getFireballPaths() {
  const fireballAnimationImagePaths = [];

  for (let i = 0; i < 2; i++) {
    const num = (i + 1);
    const imagePath = 'assets/images/fireball/fireball-' + num + '.png';

    fireballAnimationImagePaths.push(imagePath);
  }

  return fireballAnimationImagePaths;
}


/**
 * Gets paths to all images in the basket sequence
 * @returns {Array<String>} An array of image paths
 */
function getBasketPaths() {
  const basketAnimationImagePaths = [];

  for (let i = 0; i < 2; i++) {
    const num = (i + 1);
    const imagePath = 'assets/images/basket/basket-' + num + '.gif';

    basketAnimationImagePaths.push(imagePath);
  }

  return basketAnimationImagePaths;
}


/**
 * Gets paths to the special basket image
 * @returns {String} An image path
 */
function getSpecialBasketPath() {
  return 'assets/images/basket/basket-special.png';
}


/**
 * Gets paths to all images in the basket sequence
 * @returns {Array<String>} An array of image paths
 */
function getCurryPaths() {
  const curryAnimationImagePaths = [];

  curryAnimationImagePaths.push('assets/images/curry/curry-back.gif');
  curryAnimationImagePaths.push('assets/images/curry/curry-shot.gif');

  return curryAnimationImagePaths;
}


/**
 * Gets paths to all images in the intro sequence
 * @returns {Array<String>} An array of image paths
 */
function getIntroPaths() {
  const introImagePaths = [];

  introImagePaths.push('assets/images/intro/br-logo-white.png');
  introImagePaths.push('assets/images/intro/ua-logo.png');

  return introImagePaths;
}


/**
 * Gets paths to all images in the swipe instruction sequence
 * @returns {Array<String>} An array of image paths
 */
function getSwipeInstructionsPaths() {
  const swipeInstructionPaths = [];

  for (let i = 0; i < 14; i++) {
    const imagePath = 'assets/images/instructions/swipe' + i + '.png';

    swipeInstructionPaths.push(imagePath);
  }

  return swipeInstructionPaths;
}


/**
 * Gets paths to all images in the tilt instruction sequence
 * @returns {Array<String>} An array of image paths
 */
function getTiltInstructionsPaths() {
  const tiltInstructionPaths = [];

  for (let i = 0; i < 5; i++) {
    const imagePath = 'assets/images/instructions/tilt' + i + '.png';

    tiltInstructionPaths.push(imagePath);
  }

  return tiltInstructionPaths;
}


/**
 * Gets paths to all images in the landing sequence
 * @returns {Array<String>} An array of image paths
 */
function getLandingPaths() {
  const landingAnimationImagePaths = [];

  for (let i = 0; i < 218; i++) {
    if (i % 2 !== 0) {
      const imagePath = 'assets/images/start/title' + i + '.png';

      landingAnimationImagePaths.push(imagePath);
    }
  }

  return landingAnimationImagePaths;
}


/**
 * Gets path to background graphic
 * @returns {String} An image path
 */
function getBackgroundImagePath() {
  return 'assets/images/background/background.png';
}


/**
 * Gets game level data
 * @returns {Array<Object>} An array of level objects
 */
function getLevelData() {
  return [
    {
      level: 1,
      title: 'Level 1',
      backgroundColor: config.hornetGreen,
      basketSpeed: 1,
      time: 25,
      minimumShots: 10,
      minimumPercentage: 0.6,
    },
    {
      level: 2,
      title: 'Level 2',
      backgroundColor: config.lakerPurple,
      basketSpeed: 2,
      time: 25,
      minimumShots: 10,
      minimumPercentage: 0.6,
    },
    {
      level: 3,
      title: 'Level 3',
      backgroundColor: config.warriorBlue,
      basketSpeed: 3,
      time: 30,
      minimumShots: 10,
      minimumPercentage: 0.7,
    },
  ];
}


/**
 * Gets the interstitial data image Paths
 * @returns {Array<String>} An array of image paths
 */
function getSplashInterstitialPaths() {
  const pathArray = [];

  for (let i = 0; i < 48; i++) {
    pathArray.push('assets/images/interstitial/splash' + i + '.png');
  }

  return pathArray;
}


/**
 * Gets interstitial data
 * @returns {Array<Object>} An array of level objects
 */
function getInterstitialData() {
  return [
    {
      level: 1,
      backgroundColor: config.greenColor,
      imagePaths: [
        'assets/images/interstitial/steph-smile.png',
      ],
      imageWidth: 400,
      imageHeight: 404,
      animationTime: 0,
      text: [
        'Keep cooking, chef!',
        'You\'re starting to\nheat up! keep chucking!',
        'That looks like the\nstroke of a\nSplash Brother!',
      ],
    },
    {
      level: 2,
      backgroundColor: config.yellowColor,
      imageWidth: 260,
      imageHeight: 404,
      imagePaths: getSplashInterstitialPaths(),
      animationTime: 2,
      text: [
        'Lock in! You\'re on\nyour way to becoming\na Splash Brother!',
        'You\'re on fire now!\nKeep it going!',
        'Splash! Every shot is\na good shot for you\nright now!',
      ],
    },
  ];
}


/**
 * Gets the interstitial data image Paths
 * @returns {Array<String>} An array of image paths
 */
function getInterstitialPaths() {
  const pathArray = [];
  const interstitialData = getInterstitialData();

  for (let i = 0; i < interstitialData.length; i++) {
    for (let ii = 0; ii < interstitialData[i].imagePaths.length; ii++) {
      pathArray.push(interstitialData[i].imagePaths[ii]);
    }
  }

  return pathArray;
}


/**
 * Gets game level data
 * @returns {Object} Game over data
 */
function getGameOverData() {
  return {
    backgroundColor: config.greyColor,
    loopAnimation: false,
    animationTime: 1,
    animationDelay: 1,
    imagePaths: [
      'assets/images/interstitial/steph-mad0.png',
      'assets/images/interstitial/steph-mad1.png',
    ],
    text: [
      'You\'re better than that.\nGet back in the gym and\nwork on your stroke.',
      'You won\'t go anywhere\nshooting like that.',
    ],
  };
}


/**
 * Gets the interstitial data image Paths
 * @returns {Array<String>} An array of image paths
 */
function getGameOverDataPaths() {
  const pathArray = [];
  const gameOverData = getGameOverData();

  for (let i = 0; i < gameOverData.imagePaths.length; i++) {
    pathArray.push(gameOverData.imagePaths[i]);
  }

  return pathArray;
}


/**
 * Gets game level data
 * @returns {Object} Game won data
 */
function getGameWonData() {
  return {
    backgroundColor: config.yellowColor,
    imageWidth: 260,
    imageHeight: 404,
    animationTime: 1,
    loopAnimation: true,
    backgroundImagePaths: [
      'assets/images/interstitial/sneaker-bg0.png',
      'assets/images/interstitial/sneaker-bg1.png',
      'assets/images/interstitial/sneaker-bg2.png',
      'assets/images/interstitial/sneaker-bg3.png',
      'assets/images/interstitial/sneaker-bg4.png',
      'assets/images/interstitial/sneaker-bg5.png',
      'assets/images/interstitial/sneaker-bg6.png',
      'assets/images/interstitial/sneaker-bg7.png',
      'assets/images/interstitial/sneaker-bg8.png',
      'assets/images/interstitial/sneaker-bg9.png',
      'assets/images/interstitial/sneaker-bg10.png',
      'assets/images/interstitial/sneaker-bg11.png',
      'assets/images/interstitial/sneaker-bg12.png',
      'assets/images/interstitial/sneaker-bg13.png',
      'assets/images/interstitial/sneaker-bg14.png',
      'assets/images/interstitial/sneaker-bg15.png',
      'assets/images/interstitial/sneaker-bg16.png',
      'assets/images/interstitial/sneaker-bg17.png',
      'assets/images/interstitial/sneaker-bg18.png',
      'assets/images/interstitial/sneaker-bg19.png',
    ],
    imagePaths: [
      'assets/images/interstitial/sneaker0.png',
      'assets/images/interstitial/sneaker1.png',
      'assets/images/interstitial/sneaker2.png',
      'assets/images/interstitial/sneaker3.png',
      'assets/images/interstitial/sneaker4.png',
      'assets/images/interstitial/sneaker5.png',
      'assets/images/interstitial/sneaker6.png',
      'assets/images/interstitial/sneaker7.png',
      'assets/images/interstitial/sneaker8.png',
      'assets/images/interstitial/sneaker9.png',
      'assets/images/interstitial/sneaker10.png',
    ],
    text: [
      'Congratulations!\nYou have MVP-level game!',
      'You got game! It\'s time you\ngot your own shoe deal!',
    ],
  };
}


/**
 * Gets the interstitial data image Paths
 * @returns {Array<String>} An array of image paths
 */
function getGameWonDataPaths() {
  const pathArray = [];
  const gameWonData = getGameWonData();

  for (let i = 0; i < gameWonData.imagePaths.length; i++) {
    pathArray.push(gameWonData.imagePaths[i]);
  }

  return pathArray;
}

function getGameWonBackgroundPaths() {
  const pathArray = [];
  const gameWonData = getGameWonData();

  for (let i = 0; i < gameWonData.backgroundImagePaths.length; i++) {
    pathArray.push(gameWonData.backgroundImagePaths[i]);
  }

  return pathArray;
}


/**
 * Gets game paused data
 * @returns {Object} Game paused data
 */
function getPausedData() {
  return [
    'Popcorn break!<br/>Go vertical with your phone to get back in the game.',
  ];
}


/**
 * Gets game paused data
 * @returns {Object} Game paused data
 */
function getShimmyData() {
  return {
    imageWidth: 36,
    imageHeight: 98,
    animationTime: 0.5,
    backgroundColor: config.warriorBlue,
    imagePaths: [
      'assets/images/curry/curry-shimmy0.png',
      'assets/images/curry/curry-shimmy1.png',
      'assets/images/curry/curry-shimmy2.png',
      'assets/images/curry/curry-shimmy3.png',
      'assets/images/curry/curry-shimmy4.png',
      'assets/images/curry/curry-shimmy5.png',
    ],
  };
}


/**
 * Gets paths to all images
 * @returns {Array<String>} An array of image paths
 */
function getAllPaths() {
  const ballPaths = getBallPaths();
  const fireballPaths = getFireballPaths();
  const basketPaths = getBasketPaths();
  const specialBasketPath = getSpecialBasketPath();
  const explosionPaths = getExplosionPaths();
  const splashPaths = getSplashPaths();
  const interstitalPaths = getInterstitialPaths();
  const gameOverPaths = getGameOverDataPaths();
  const gameWonPaths = getGameWonDataPaths();
  const gameWonBackgroundPaths = getGameWonBackgroundPaths();
  const curryPaths = getCurryPaths();
  const landingPaths = getLandingPaths();
  const backgroundImage = getBackgroundImagePath();
  const tiltInstructionPaths = getTiltInstructionsPaths();
  const swipeInstructionPaths = getSwipeInstructionsPaths();
  const shimmyPaths = getShimmyData().imagePaths;
  const allImagePaths =
    explosionPaths
    .concat(ballPaths)
    .concat(fireballPaths)
    .concat(interstitalPaths)
    .concat(gameOverPaths)
    .concat(splashPaths)
    .concat(basketPaths)
    .concat(specialBasketPath)
    .concat(curryPaths)
    .concat(landingPaths)
    .concat(gameWonPaths)
    .concat(gameWonBackgroundPaths)
    .concat(tiltInstructionPaths)
    .concat(swipeInstructionPaths)
    .concat(shimmyPaths);

  allImagePaths.push(backgroundImage);

  return allImagePaths;
}


const data = {
  ballPaths: getBallPaths(),
  fireballPaths: getFireballPaths(),
  basketPaths: getBasketPaths(),
  specialBasketPath: getSpecialBasketPath(),
  explosionPaths: getExplosionPaths(),
  splashPaths: getSplashPaths(),
  texturePaths: getAllPaths(),
  curryPaths: getCurryPaths(),
  gameOverData: getGameOverData(),
  gameWonData: getGameWonData(),
  gameWonBackgroundPaths: getGameWonBackgroundPaths(),
  landingPaths: getLandingPaths(),
  backgroundImage: getBackgroundImagePath(),
  interstitial1Data: getInterstitialData()[0],
  interstitial2Data: getInterstitialData()[1],
  pausedData: getPausedData(),
  introPaths: getIntroPaths(),
  tiltInstructionPaths: getTiltInstructionsPaths(),
  swipeInstructionPaths: getSwipeInstructionsPaths(),
  shimmyData: getShimmyData(),
  soundPaths: [
    {
      id: 'theme',
      path: 'assets/sounds/8-bit-hit-jp.mp3',
    },
    {
      id: 'allsounds',
      path: 'assets/sounds/allsounds.m4a',
    },
  ],
  levelData: getLevelData(),
  interstitialData: getInterstitialData(),
};

export default data;



/** WEBPACK FOOTER **
 ** ./assets/js/src/data/data.js
 **/